define('adminImprintTechnologiesCreateEditView',[
  'module',
  'underscore',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!adminImprintTechnologiesCreateEditTpl',
  'savingBehavior',
  'dynamicTextView',
  'autocompleteView'
], function (
  module,
  _,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  DynamicTextView,
  AutocompleteView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      individualPrinting: '#individualPrinting',
      allowOtherColors: '.allowOtherColors'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.individualPrinting': 'onChangeIndividualPrinting',
      'change .checkbox-input': 'onChangeCheckboxInput'
    },

    regions: {
      nameRegion: '.name-region',
      vrpWarningMessageRegion: '.vrp-warning-message-region',
      pantoneColorSelectionRegion: '.pantone-color-selection-region'
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    onChangeCheckboxInput: function (e) {
      var inp = $(e.target);
      this.model.set(inp.data('field-name'), inp.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeIndividualPrinting: function () {
      this.model.set('individualPrinting', this.ui.individualPrinting.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    initialize: function (options) {
      this.model = options.itModel;
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function () {
      $.material.init();

      this.nameDtView = new DynamicTextView({
        model: this.model.get('name'),
        noSaving: true,
        hideGlossary: true
      });
      this.nameDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('nameRegion').show(this.nameDtView);

      this.showPantoneColorSelectionAutocomplete();
      this.updateAllowOtherColorsState();

      this.vrpWarningMessageDtView = new DynamicTextView({
        model: this.model.get('vrpWarningMessage'),
        noSaving: true,
        hideGlossary: true,
        textAreaMode: true
      });
      this.vrpWarningMessageDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('vrpWarningMessageRegion').show(this.vrpWarningMessageDtView);
    },

    showPantoneColorSelectionAutocomplete: function () {
      var autoCompleteOptions = this.getAutocompleteOptions(
        'compuzz2',
        'v2/colorselections',
        'name',
        'name',
        'refPantoneColorSelection',
        _.bind(function (fieldName, model) {
          if (model) {
            this.model.set('refPantoneColorSelection', model.toJSON());
          } else {
            this.model.set('refPantoneColorSelection', null);
          }
          this.updateAllowOtherColorsState();
          this.triggerMethod('enable:cancel:confirm');
        }, this)
      );

      var refPantoneColorSelection = this.model.get('refPantoneColorSelection');
      if (refPantoneColorSelection && refPantoneColorSelection.name) {
        autoCompleteOptions.value = refPantoneColorSelection.name;
      }

      this.pantoneColorSelectionView = new AutocompleteView(autoCompleteOptions);
      this.getRegion('pantoneColorSelectionRegion').show(this.pantoneColorSelectionView);
    },

    updateAllowOtherColorsState: function () {
      var hasColorSelection = !!this.model.get('refPantoneColorSelection');
      this.ui.allowOtherColors.prop('disabled', !hasColorSelection);
      if (!hasColorSelection) {
        this.ui.allowOtherColors.prop('checked', true);
        this.model.set('allowOtherColors', true);
      }
    },

    onConfirm: function () {
      if (this.validate(this.fieldsToValidate)) {
        if (this.pantoneColorSelectionView && !this.pantoneColorSelectionView.ui.autocomplete.val()) {
          this.model.set('refPantoneColorSelection', null);
          this.model.set('allowOtherColors', true);
        }
        this.model.save();
      }
    },

    onSave: function () {
      this.triggerMethod('saved');
      this.hide();
    },

    onSaveError: function (model, response) {
      if (response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    }
  });

  module.exports = CreateEditLayoutView;
});
